import React from 'react'

export default function AboutBlog() {
    return (
        <div className='section-secondary-bg section-padding 1440:py-[5rem]  999:py-[3.8rem] 768:py-[2.9rem] py-[25px] px-[2.5rem]'>
            <div className='grid grid-cols-2 items-start 1550:gap-[3.125rem] gap-[2.5rem]'>
                <div className='grid  grid-cols-1   items-center justify-center pt-[1.875rem] 1550:gap-[1.875rem] 1350:gap-[1.25rem]'>
                    <div className={` 1550:border-[2.5rem]  1350:border-[30px] 768:border-[25px] border-[20px] border-[#FACBAE] rounded-[20px] `}>
                        <div className=' orange-border 999:w-full 600:h-[23.125rem] h-[60vw] bg-white rounded-[1.25rem] overflow-hidden '>

                        </div>
                    </div>

                    <div className='space-y-[.625rem] '>
                        <p className='text-[1.875rem]'>Lorem ipsum dolor sit amet consectetur. Tempus
                            tellus egestas ullamcorper in blandit gravida.</p>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                    </div>
                </div>
                <div className='grid  grid-cols-1   items-center justify-center pt-[1.875rem] 1550:gap-[1.875rem] 1350:gap-[1.25rem]'>
                    <div className={` 1550:border-[2.5rem]  1350:border-[30px] 768:border-[25px] border-[20px] border-[#FACBAE] rounded-[20px] `}>
                        <div className=' orange-border 999:w-full 600:h-[23.125rem] h-[60vw] bg-white rounded-[1.25rem] overflow-hidden '>

                        </div>
                    </div>

                    <div className='space-y-[.625rem] '>
                        <p className='text-[1.875rem]'>Lorem ipsum dolor sit amet consectetur. Tempus
                            tellus egestas ullamcorper in blandit gravida.</p>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                        <div className='secondary-text flex items-start justify-start gap-[.625rem]'>
                            <div className='bg-[#dd] w-[.625rem] h-[.625rem] mt-[9px] rounded-[50%] bg-[#999CA4]'>

                            </div>
                            <p className='w-[90%] font-[450] text-[1.25rem] leading-[29px]'>Lorem ipsum dolor sit amet consectetur. Hac sem facilisis tristique ac pharetra nisl quis. Scelerisque blandit duis eu orci diam.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className=''>
                <div className='grid 999:grid-cols-2 grid-cols-1   items-center justify-center py-[3.75rem] gap-[3.75rem]'>
                    <div className={` 1550:border-[2.5rem]  1350:border-[30px] 768:border-[25px] border-[20px] border-[#FACBAE] rounded-[20px] `}>
                        <div className=' orange-border 999:w-full 600:h-[23.125rem] h-[60vw] bg-white rounded-[1.25rem] overflow-hidden '>

                        </div>
                    </div>

                    <div className='space-y-[.625rem] '>
                        <p className='text-[1.875rem]'>Lorem ipsum dolor sit amet consectetur. Tempus
                            tellus egestas ullamcorper in blandit gravida.</p>
                        <p className='text-[1.25rem] font-[450] pt-[10px] secondary-text'>Lorem ipsum dolor sit amet consectetur. Nulla eu tempus lectus sed nibh convallis velit vulputate. Nibh sit commodo sed quam quam velit id morbi dictum. Fusce viverra phasellus leo consectetur. Sit nunc egestas donec habitant phasellus pharetra interdum suscipit eget. Euismod vestibulum risus varius netus. Faucibus ullamcorper amet cursus dignissim risus. Pellentesque tellus ultricies pulvinar maecenas. Vel iaculis odio ornare hendrerit ultrices tortor justo non pellentesque. Ut purus mauris ornare id. Eu aliquam mi posuere blandit cursus nam.</p>

                    </div>
                </div>
                <div className='grid 999:grid-cols-2 grid-cols-1   items-center justify-center py-[3.75rem] gap-[3.75rem]'>
                    <div className='space-y-[.625rem] '>
                        <p className='text-[1.875rem]'>Lorem ipsum dolor sit amet consectetur. Tempus
                            tellus egestas ullamcorper in blandit gravida.</p>
                        <p className='text-[1.25rem] font-[450] pt-[10px] secondary-text'>Lorem ipsum dolor sit amet consectetur. Nulla eu tempus lectus sed nibh convallis velit vulputate. Nibh sit commodo sed quam quam velit id morbi dictum. Fusce viverra phasellus leo consectetur. Sit nunc egestas donec habitant phasellus pharetra interdum suscipit eget. Euismod vestibulum risus varius netus. Faucibus ullamcorper amet cursus dignissim risus. Pellentesque tellus ultricies pulvinar maecenas. Vel iaculis odio ornare hendrerit ultrices tortor justo non pellentesque. Ut purus mauris ornare id. Eu aliquam mi posuere blandit cursus nam.</p>

                    </div>
                    <div className={` 1550:border-[2.5rem]  1350:border-[30px] 768:border-[25px] border-[20px] border-[#FACBAE] rounded-[20px] `}>
                        <div className=' orange-border 999:w-full 600:h-[23.125rem] h-[60vw] bg-white rounded-[1.25rem] overflow-hidden '>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}
